import React, { Component } from 'react';

const FilterButton = (props) => {
    const { filter } = props;
    const getSelectedClass = () => {
      return props.selected && props.selected.id === filter.id ? 'selected' : '';
    };
    return (
      <li
        className={`${getSelectedClass()}`}
        onClick={props.toggleSelected}
      >
        <span className="blueTick" />
        <p className="font14 defaultGreyText">{filter.text}</p>
      </li>
    );
  }
  export default FilterButton;
